import React from 'react';
import FaqsLayout from './FaqsLayout';

const Tour24FaqsPage = () => {
    return <FaqsLayout simple={false} webTour={false} />;
};

export default Tour24FaqsPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/Tour24FaqsPage.tsx